import { LayoutHOC } from "base/ui/layout/layout";
import { wasteHandoverRegistrationRoutes } from "./routes";
import { createWasteHandoverRegistrationList } from ".";
import { createCreateUpdateWasteHandoverRegistration } from "./CreateUpdate/createUpdateWasteHandoverRegistration";
import { services } from "stores/root_store";

export const createWasteHandoverRegistrationPage = (layoutHOC: LayoutHOC) => {
    const List = createWasteHandoverRegistrationList()
    const Create = createCreateUpdateWasteHandoverRegistration(services.wasteHandoverPlanServices)
    const Edit = createCreateUpdateWasteHandoverRegistration(services.wasteHandoverPlanServices)

    const WasteHandoverRegistrationPage = layoutHOC(wasteHandoverRegistrationRoutes);

    return () => (
        <WasteHandoverRegistrationPage
            List={List}
            Create={Create}
            Edit={Edit}
        />
    );
};

